import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/767b4790/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentCode = makeShortcode("ComponentCode");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ComponentCode name="Ordered List" component="list" variation="list--ordered" hasReactVersion="orderedlist--default" hasVueVersion="list--default&knob-ordered=true" hasAngularVersion="?path=/story/list--basic" codepen="jRqrry" mdxType="ComponentCode" />
    <ComponentCode name="Unordered List" component="list" variation="list" hasReactVersion="unorderedlist--default" hasVueVersion="list--default" hasAngularVersion="?path=/story/list--basic" codepen="GLZqNR" mdxType="ComponentCode"></ComponentCode>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      